import logger from "../../utils/LoggerFrontend";
import { ALL_CAMPAIGN_ROLES, MANAGERS_ROLES, SUBSCRIBERS_ROLES } from "./CampaignMembers.constants";

export function updateMemberRole({ members, membersIds = [], role }) {
  return members.map((member) => {
    if (!ALL_CAMPAIGN_ROLES.includes(role)) {
      logger.log(
        "error:CampaignMembers:CampaignMembers.utils:updateMemberRole",
        "the role doesn't exists",
        { role }
      );

      return member;
    }

    if (MANAGERS_ROLES.includes(role) && membersIds.length > 1) {
      logger.log(
        "error:CampaignMembers:CampaignMembers.utils:updateMemberRole",
        "several members ids not allowed for manager roles (owner/recruiter)",
        { membersIds }
      );
      return member;
    }

    if (!member.roles) {
      member.roles = [];
    }

    // Remove the role from the members that are not in the members array
    if (!membersIds.includes(member.id)) {
      return { ...member, roles: member.roles.filter((r) => r !== role) };
    }

    // Add the owner/recruiter + subscribers roles to the members of the array
    if (!member.roles.includes(role) && MANAGERS_ROLES.includes(role)) {
      return {
        ...member,
        roles: [...member.roles, role, ...SUBSCRIBERS_ROLES]
      };
    }

    // Add the role role to the members of the array in any other case
    if (!member.roles.includes(role)) {
      return { ...member, roles: [...member.roles, role] };
    }

    return member;
  });
}
